import { createSlice } from '@reduxjs/toolkit';
import { httpPost } from '../../../util/Rest';
import { DEBTOR } from '../../../constants/MicroServiceConstants';
import { deleteWorkQueueByAccountNumber } from '../WorkQueue';

const initialData = {
  notesData: {},
  notesStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  dropDownData: [],
  subTypeDropDownData: [],
};

const slice = createSlice({
  name: 'legalInformation',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    postNotesData: (state, action) => {
      state.notesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.status != 200 ? action.payload.response : 'Account note updates were saved successfully';
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSubTypeDropDownData: (state, action) => {
      state.subTypeDropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload;
      state.isLoading = false;
    },
    resetStatus: (state) => {
      state.notesStatus = null;
      state.errorMsg = null;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.notesStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

const {
  postNotesData,
  fetchStart,
  resetMsg,
  fetchError,
  resetStatus,
  fetchDropDownData,
  fetchSubTypeDropDownData,
} = slice.actions;

export const postNotesInformation = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/save/addnotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postNotesData(data));
          dispatch(
            deleteWorkQueueByAccountNumber({ accountNumber: details?.accountNumber, isDirty: true }),
          );
          // dispatch(fetchSuccess(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getNotesActions = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('lookup/find/all/lookup', {
      typeCode: ['NOTES_ACTION', 'SUB_TYPE'],
    })
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchDropDownData(data?.data?.NOTES_ACTION ? data?.data?.NOTES_ACTION : []));
          dispatch(fetchSubTypeDropDownData(data?.data?.SUB_TYPE ? data?.data?.SUB_TYPE : []));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetPostStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
